const React = require('react')
const { useState, useEffect } = require('react')
const {
    Row,
    Col,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    ButtonGroup,
    Button
} = require('reactstrap')
const { useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner, CopyButton } = require('@components')
const { useAddressMap, useDecodeEvents, useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/pages/transaction/logs.transaction.css')

const TransactionLogs = props => {
    const { data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { getAddressName } = useAddressMap()
    const { getDecodedLogs } = useDecodeEvents()

    const [topicFormats, setTopicFormats] = useState({})
    const [dataFormat, setDataFormat] = useState({})
    const isMobile = useResponsive(BREAKPOINTS.small)
    const [loading, setLoading] = useState(true)

    const [logs, setLogs] = useState([])

    useEffect(() => {
        setLoading(true)
        if (!data) return

        const fetchLogs = async () => {
            const decodedLogs = await getDecodedLogs(data.details.logs)

            setLogs(decodedLogs)
            setLoading(false)
        }
        fetchLogs()
    }, [data])

    const handleFormatChange = (logIndex, topicIndex, format) => {
        setTopicFormats(prev => ({
            ...prev,
            [logIndex]: {
                ...prev[logIndex],
                [topicIndex]: format
            }
        }))
    }

    const handleDataFormatChange = (logIndex, format) => {
        setDataFormat(prev => ({
            ...prev,
            [logIndex]: format
        }))
    }

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    <span style={{ marginBottom: '16px', display: 'block', color: 'var(--white-color)' }}>
                        Transaction Receipt Event Logs
                    </span>
                    {data?.details.logs.map((log, index) => (
                        <div key={index}>
                            <div className='log-item-container'>
                                <div className='log-index-wrapper'>
                                    <div className='log-index-circle'>{log.logIndex}</div>
                                </div>
                                <>
                                    <Row className='table-info-row' noGutters>
                                        <Col xs={12} sm={2} className='d-flex align-items-start'>
                                            <span
                                                className='log-label'
                                                style={{
                                                    marginLeft: !isMobile && 'auto',
                                                    marginBottom: isMobile && '8px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                Address
                                            </span>
                                        </Col>
                                        <Col xs={12} sm={10} className='d-flex align-items-start'>
                                            <span
                                                className={`info-value ${network.name}-text-color`}
                                                onClick={() => {
                                                    history.push(`/${network.name}/address/${log.address}`)
                                                }}
                                                style={{ cursor: 'pointer', wordBreak: 'break-all' }}
                                            >
                                                {log.address}
                                            </span>
                                            &nbsp;
                                            <CopyButton
                                                id={`copy-transaction-address-${log.logIndex}`}
                                                data={log.address}
                                                text={'Copy address'}
                                            />
                                            {getAddressName(log.address) && (
                                                <>
                                                    &nbsp;
                                                    <span className='info-value'>({getAddressName(log.address)})</span>
                                                </>
                                            )}
                                        </Col>
                                    </Row>
                                    {logs[index]?.eventName && (
                                        <Row className='table-info-row' noGutters>
                                            <Col xs={12} sm={2} className='d-flex align-items-start'>
                                                <span
                                                    className='log-label'
                                                    style={{
                                                        marginLeft: !isMobile && 'auto',
                                                        marginBottom: isMobile && '8px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Name
                                                </span>
                                            </Col>
                                            <Col xs={12} sm={10} className='d-flex align-items-start'>
                                                <span className='info-value log-data'>
                                                    {logs[index].eventName} (
                                                    {(() => {
                                                        let indexedCount = 0
                                                        return logs[index].details.map((input, i) => (
                                                            <>
                                                                {input.indexed && `index_topic_${++indexedCount} `}
                                                                <span style={{ color: 'var(--success-color)' }}>
                                                                    {input.type}
                                                                </span>
                                                                &nbsp;
                                                                <span style={{ color: 'var(--fail-color)' }}>
                                                                    {input.name}
                                                                </span>
                                                                {i < logs[index].details.length - 1 && ', '}
                                                            </>
                                                        ))
                                                    })()}
                                                    )
                                                </span>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row className='table-info-row' noGutters>
                                        <Col xs={12} sm={2} className='d-flex align-items-start'>
                                            <span
                                                className='log-label'
                                                style={{
                                                    marginLeft: !isMobile && 'auto',
                                                    marginBottom: isMobile && '8px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                Topic
                                            </span>
                                        </Col>
                                        <Col xs={12} sm={10}>
                                            <div className='topics-container'>
                                                {(() => {
                                                    const indexedInputs =
                                                        logs[index]?.details.filter(input => input.indexed) || []

                                                    return log.topics.map((topic, topicIndex) => (
                                                        <div
                                                            key={topicIndex}
                                                            className='d-flex flex-column flex-md-row align-items-start'
                                                        >
                                                            <div className='d-flex align-items-center'>
                                                                <span className='status-box pending'>
                                                                    {topicIndex}
                                                                    {topicIndex > 0 &&
                                                                        indexedInputs[topicIndex - 1] &&
                                                                        `: ${indexedInputs[topicIndex - 1].name}`}
                                                                </span>
                                                                &nbsp;
                                                                {topicFormats &&
                                                                    topicIndex > 0 &&
                                                                    indexedInputs.length > 0 && (
                                                                        <>
                                                                            <UncontrolledDropdown className='ms-1 d-inline-block'>
                                                                                <DropdownToggle
                                                                                    caret
                                                                                    outline
                                                                                    className='table-dropdown-toggle'
                                                                                    style={{ border: 'none' }}
                                                                                >
                                                                                    {topicFormats[log.logIndex]?.[
                                                                                        topicIndex
                                                                                    ] || 'Dec'}
                                                                                </DropdownToggle>
                                                                                <DropdownMenu className='table-dropdown-menu'>
                                                                                    {['Dec', 'Hex'].map(format => (
                                                                                        <DropdownItem
                                                                                            key={format}
                                                                                            className={`table-dropdown-item${
                                                                                                topicFormats[
                                                                                                    log.logIndex
                                                                                                ]?.[topicIndex] ===
                                                                                                format
                                                                                                    ? ' active'
                                                                                                    : ''
                                                                                            }`}
                                                                                            onClick={() =>
                                                                                                handleFormatChange(
                                                                                                    log.logIndex,
                                                                                                    topicIndex,
                                                                                                    format
                                                                                                )
                                                                                            }
                                                                                            active={
                                                                                                topicFormats[
                                                                                                    log.logIndex
                                                                                                ]?.[topicIndex] ===
                                                                                                format
                                                                                            }
                                                                                            style={{
                                                                                                justifyContent:
                                                                                                    'flex-start'
                                                                                            }}
                                                                                        >
                                                                                            {format === 'Dec'
                                                                                                ? 'Decode'
                                                                                                : 'Hex'}
                                                                                        </DropdownItem>
                                                                                    ))}
                                                                                </DropdownMenu>
                                                                            </UncontrolledDropdown>
                                                                            &nbsp;
                                                                        </>
                                                                    )}
                                                            </div>
                                                            <span
                                                                className='info-value log-data mt-2 mt-sm-0'
                                                                style={{ flex: 1, alignSelf: 'center' }}
                                                            >
                                                                {(() => {
                                                                    if (topicIndex === 0) {
                                                                        return topic
                                                                    }

                                                                    if (
                                                                        !topicFormats[log.logIndex]?.[topicIndex] ||
                                                                        topicFormats[log.logIndex]?.[topicIndex] ===
                                                                            'Dec'
                                                                    ) {
                                                                        if (
                                                                            logs[index]?.details[topicIndex - 1]
                                                                                ?.type === 'address'
                                                                        ) {
                                                                            return (
                                                                                <span
                                                                                    className={`${network.name}-text-color cursor-pointer`}
                                                                                    onClick={() =>
                                                                                        history.push(
                                                                                            `/${network.name}/address/${
                                                                                                logs[index]?.details[
                                                                                                    topicIndex - 1
                                                                                                ]?.value
                                                                                            }`
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        logs[index]?.details[
                                                                                            topicIndex - 1
                                                                                        ]?.value
                                                                                    }
                                                                                </span>
                                                                            )
                                                                        }

                                                                        return typeof logs[index]?.details[
                                                                            topicIndex - 1
                                                                        ]?.value === 'bigint'
                                                                            ? Number(
                                                                                  logs[index]?.details[topicIndex - 1]
                                                                                      ?.value
                                                                              )
                                                                            : logs[index]?.details[topicIndex - 1].value
                                                                    }

                                                                    return topic
                                                                })()}
                                                            </span>
                                                        </div>
                                                    ))
                                                })()}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='table-info-row' noGutters>
                                        <Col xs={12} sm={2} className='d-flex align-items-start'>
                                            <span
                                                className='log-label'
                                                style={{
                                                    marginLeft: !isMobile && 'auto',
                                                    marginBottom: isMobile && '8px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                Data
                                            </span>
                                        </Col>
                                        <Col xs={12} sm={10}>
                                            <div className='d-flex align-items-start'>
                                                <div
                                                    className='status-box pending d-flex justify-content-between align-items-center'
                                                    style={{ padding: '10px', flex: 1 }}
                                                >
                                                    {log.data === '0x' || !logs[index]?.eventName ? (
                                                        <span
                                                            className='info-value log-data'
                                                            style={{ wordBreak: 'break-all' }}
                                                        >
                                                            {log.data}
                                                        </span>
                                                    ) : (
                                                        <>
                                                            <div
                                                                className='info-value log-data'
                                                                style={{
                                                                    wordBreak: 'break-all',
                                                                    flex: 1,
                                                                    paddingRight: '10px'
                                                                }}
                                                            >
                                                                {!dataFormat[log.logIndex] ||
                                                                dataFormat[log.logIndex] === 'Dec' ? (
                                                                    <>
                                                                        {(() => {
                                                                            const notIndexedInputs =
                                                                                logs[index]?.details.filter(
                                                                                    input => !input.indexed
                                                                                ) || []

                                                                            return notIndexedInputs.map(input => (
                                                                                <div
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        marginBottom: '8px',
                                                                                        maxWidth: '100%',
                                                                                        overflowWrap: 'break-word'
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        style={{
                                                                                            color: 'var(--grey-color)',
                                                                                            whiteSpace: 'pre-wrap'
                                                                                        }}
                                                                                    >
                                                                                        {input.name}
                                                                                    </span>
                                                                                    <span
                                                                                        style={{
                                                                                            color: 'var(--grey-color)'
                                                                                        }}
                                                                                    >
                                                                                        :{' '}
                                                                                    </span>
                                                                                    {input.type === 'address' ? (
                                                                                        <span
                                                                                            className={`${network.name}-text-color cursor-pointer`}
                                                                                            onClick={() =>
                                                                                                history.push(
                                                                                                    `/${network.name}/address/${input.value}`
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {input.value}
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span>
                                                                                            {typeof input.value ===
                                                                                            'bigint'
                                                                                                ? Number(
                                                                                                      input.value
                                                                                                  ).toLocaleString()
                                                                                                : input.value.toLocaleString()}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            ))
                                                                        })()}
                                                                    </>
                                                                ) : (
                                                                    log.data
                                                                )}
                                                            </div>
                                                            <ButtonGroup>
                                                                <Button
                                                                    outline
                                                                    size='sm'
                                                                    disabled={
                                                                        !dataFormat[log.logIndex] ||
                                                                        dataFormat[log.logIndex] === 'Dec'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDataFormatChange(log.logIndex, 'Dec')
                                                                    }
                                                                >
                                                                    Dec
                                                                </Button>
                                                                <Button
                                                                    outline
                                                                    size='sm'
                                                                    disabled={dataFormat[log.logIndex] === 'Hex'}
                                                                    onClick={() =>
                                                                        handleDataFormatChange(log.logIndex, 'Hex')
                                                                    }
                                                                >
                                                                    Hex
                                                                </Button>
                                                            </ButtonGroup>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            </div>
                            {index < data.length - 1 && <div className='table-divider' />}
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

module.exports = { TransactionLogs }
